import React, { useState, useEffect, useCallback, useRef } from "react";
import { Input } from "antd";

import { safeGet } from "src/shared/utils";
import styles from "./index.module.scss";
import "./custom.style.scss";
import SearchItem from "./SearchItem";
import NoSearch from "src/assets/no-search.png";
import { CrossIcon } from "src/assets/crossIcon.js";
import { SearchIcon } from "src/assets/search-icon.js";
import TripleDotsLoader from "src/shared/components/TripleDotsLoader";

interface ISearchProps {
  closeSearch: () => void;
  searchMetric: (text: string) => void;
  searchResult: any[];
  open?: boolean;
  target?: string;
  searchSuccess: boolean;
  searchPending: boolean;
  resetSearch: () => void;
}
const Search = (props: ISearchProps) => {
  const [inputValue, setInput] = useState("");
  const inputRef = useRef<Input>(null);
  const { searchMetric, closeSearch } = props;
  const search = useCallback(
    (value: string) => {
      searchMetric(value);
    },
    [searchMetric]
  );
  const handleChange = (event) => {
    setInput(safeGet(event, "target.value", ""));
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     inputRef.current && inputRef.current.focus();
  //   }, 0);
  // }, [open]);

  useEffect(() => {
    if (inputValue === "") {
      props.resetSearch();
    }
  }, [props.searchSuccess, props.searchPending]);

  useEffect(() => {
    const handler = setTimeout(() => {
      search(inputValue);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  return props.open ? (
    <main className={styles["search-container"]}>
      <div className={styles["search-input"]}>
        <div className={styles["search-icon"]}>
          <SearchIcon />
        </div>
        <div>
          <Input onChange={handleChange} placeholder={"type a metric name"} ref={inputRef} autoFocus />
        </div>
        <div className={styles["search-cancel"]} onClick={closeSearch}>
          <CrossIcon />
        </div>
      </div>
      {props.searchSuccess && props.searchResult.length > 0 && (
        <div className={styles["search-result"]}>
          {props.searchResult.map((item) => {
            const { bigNumber, vCompare, progress, successful, hasChart, isPositive } = item;
            return (
              <SearchItem
                bigNumber={bigNumber}
                vCompare={vCompare}
                label={item.label}
                key={item.id}
                id={item.metricId || item.id}
                progress={progress}
                successful={successful}
                pending={props.searchPending}
                hasChart={hasChart}
                isPositive={isPositive}
              />
            );
          })}
        </div>
      )}
      {props.searchPending && <TripleDotsLoader />}
      {props.searchSuccess && !props.searchPending && props.searchResult.length === 0 && inputValue.length !== 0 && (
        <div className={styles["no-search-container"]}>
          <img src={NoSearch} alt="no-search" />
        </div>
      )}
    </main>
  ) : null;
};
export default Search;
